import { GetApiMerchantBatchMaterialStatusResponse } from '@/services/ytt_apis/apiMerchant/batch';
import { useState } from 'react';

export default function useAddSupportingMaterialsDataSource() {
  const [dataSource, setDataSource] = useState<GetApiMerchantBatchMaterialStatusResponse['data']>(
    {},
  );

  return {
    dataSource: dataSource || {},
    updateDataSource: setDataSource,
  };
}
